import type { FaireProductEntity } from "../../entity_types/product";

export const p_2uef3hvkvz: FaireProductEntity = {
  token: "p_2uef3hvkvz",
  type: "product",
  name: "Seasonal Sangria Frozen Cocktail",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/f37db9e7117e2fdc729dbfeee2c891ece238fb70feaa5718c28ada982c52fec2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8a91e30a65077d565f031767cdf42df7c2150bf672196d0d3cbc350bb536f4df.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "Frozen Seasonal Cocktails don't get easier than this! Each bag makes 8 servings. No blenders ever! Simply add 1 750ml bottle of red wine, 1 750 ml bottle of water, and 4 oz of cinnamon whisky, shake or stir and throw in the freezer. Then serve right from the bag. \n\nOur Frozen cocktails are unique in you ONLY ever add water and spirit...NEVER any juice, mixers or additional flavors. That's one of the things that sets us apart. 100% all natural ingredients and perfect to share with friends and family at your next party.\n\n- 100% All-Natural Ingredients\n- Easy Prep:  Mix, Freeze & Serve Directly in the Bag \n- No Artificial Flavors or Colors\n- Made in the USA\n- Vegan & Gluten-Free \n- Makes 8 Servings per Bag\n- No Blender Needed\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Bold color and holiday design makes merchandising a breeze!\n-Perfect Christmas and hostess gifts for the entire holiday season",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:03.817Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
